export default {
  mambu: {
    name: 'Mambu',
    subtitle: 'Mambu Backoffice',
    tabs: {
      status: 'Status',
      configuration: 'Configuration',
    },
    task: 'Task',
    status: 'Status',
    externalAccountLinkRegistration: 'External account link registration',
    accountMirroring: 'Account synchronization',
    externalProfileLinkSync: 'External profile link synchronization',
    transactionTransferMirroring: 'Transaction transfer synchronization',
    lastErrorMessage: 'Last error message',
    lastErrorTimestamp: 'Last error date and time',
    hasError: 'Has error?',
    fields: {
      isEnabled: 'Is enabled?',
      apiConfiguration: 'API Configuration',
      basicConfiguration: 'Basic Configuration',
      editConfigurationDetails: 'Edit configuration',
      externalAccountLinkRegistration: 'External account link registration',
      accountMirroring: 'Account synchronization',
      externalProfileLinkSync: 'External profile link synchronization',
      transactionTransferMirroring: 'Transaction transfer synchronization',
      lastErrorMessage: 'Last error message',
      lastErrorTimestamp: 'Last error date and time',
      baseUrl: 'Base URL',
      apiKey: 'API Key',
      batchSize: 'Batch size',
      timeZoneOffset: 'Time zone offset (in hours)',
      clientRoleKeys: 'Client role mapping',
      productTypeKeys: 'Product type mapping',
      clientIdPrefix: 'Client id prefix',
      initialIterationMs: 'Initial iteration (in milliseconds)',
      regularIterationMs: 'Regular iteration (in milliseconds)',
      delaySeconds: 'Delay (in seconds)',
      addClientRoleKeys: 'Add client role',
      addProductTypeKeys: 'Add product type',
      addGroupRoleKeys: 'Add group role',
      veenguIndividualSolution: 'Veengu individual solution',
      veenguIndividualSolutionId: 'Veengu individual solution ID',
      veenguBusinessSolution: 'Veengu business solution',
      veenguBusinessSolutionId: 'Veengu business solution ID',
      mambuClientRoleId: 'Mambu Client Role Id',
      veenguProduct: 'Veengu product',
      veenguProductId: 'Veengu product ID',
      mambuProductTypeId: 'Mambu Product Type Id',
      mambuGroupRoleId: 'Mambu Group Role Id',
      groupRoleKeys: 'Group role mapping',
      groupIdPrefix: 'Group id prefix',
      additionalInformation: 'Additional configuration',
      validations: {
        required: 'Required',
        alreadyAdded: 'This ID is already added',
      },
      individualSolution: 'Individual solution',
      businessSolution: 'Business solution',
      product: 'Product',
      transitChannelKeys: 'Transit channel mapping',
      addTransitChannelKeys: 'Add transit channel',
      transitDepositKeys: 'Transit deposit mapping',
      addTransitDepositKeys: 'Add transit deposit',
      currency: 'Currency',
      currencyCode: 'Currency code',
      mambuTransitChannel: 'Mambu transit channel',
      mambuTransitDeposit: 'Mambu transit deposit',
    },
  },
};
